import ServerResponseContext from "./ServerResponseContext";

interface ISetHttpStatusCodeProps {
  httpStatus: number;
}

function SetHttpStatusCode({ httpStatus }: ISetHttpStatusCodeProps) {
  return (
    <ServerResponseContext.Consumer>
      {(response) => {
        if (response) {
          response.statusCode = httpStatus;
          return null;
        }

        return null;
      }}
    </ServerResponseContext.Consumer>
  );
}

export default SetHttpStatusCode;
